import classNames from 'classnames';
import React__default from 'react';
import { getPrefixCls } from '../../utils/getPrefix.js';

var prefixCls = getPrefixCls('summary');
var renderIllustration = function renderIllustration(illustration, headline) {
  if (illustration) {
    return typeof illustration === 'string' ? /*#__PURE__*/React__default.createElement("img", {
      className: "".concat(prefixCls, "_illustration"),
      src: illustration,
      alt: headline
    }) : illustration;
  }
  return null;
};
var Summary = function Summary(_ref) {
  var className = _ref.className,
    illustration = _ref.illustration,
    headline = _ref.headline,
    description = _ref.description,
    actions = _ref.actions,
    _ref$actionBar = _ref.actionBar,
    actionBar = _ref$actionBar === void 0 ? false : _ref$actionBar,
    _ref$dataTestid = _ref.dataTestid,
    dataTestid = _ref$dataTestid === void 0 ? 'summary' : _ref$dataTestid;
  return /*#__PURE__*/React__default.createElement("div", {
    "sl-test-data": dataTestid,
    className: classNames(prefixCls, className, {
      'has-actionBar': actionBar
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_content")
  }, illustration && renderIllustration(illustration, headline), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_headline")
  }, headline), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_description")
  }, description)), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_actions")
  }, actions));
};

export { Summary };
